import { helper } from '@ember/component/helper';

// Remember, NOM can't eat without arms: {{~nom~}}
// (Don't tell nom he can be replaced by {{~!~}} as soon as that bug is fixed)
export default helper(function nomHelper() {
  return ''; // NOM returns nothing. NOM eats everything. Feed NOM.
});
